import { useSelector } from 'react-redux';

import { RootState } from '../rootReducer';

export const useAuthIsAdmin = (): boolean => {
  return useSelector<RootState, boolean>(state => state.auth.isAdmin);
};
